import FormattedMessage from 'I18n/components/FormattedMessage';
import { PipelineSelect } from './PipelineSelect';
import DraggableCardSettingRows from './DraggableCardSettingRows';
import { SelectCardContentSection } from './SelectCardContentSection';
import { Flex } from 'foundations-components/components/Flex';
import { CardSectionSettingsResetButton } from './CardSectionSettingsResetButton';
import { useIsAdminView } from '../../providers/settings/CardSettingsPanelProvider';
import { useObjectTypeDefinitionTranslationOptions } from 'crm-object-board-core/objectTypeDefinition';
import { View } from 'foundations-components/components/View';
import { QuickActionSettings } from './quickActions/QuickActionSettings';
import { usePipelineId } from 'crm-object-board-core/pipeline';
import { ObjectTypeSelect } from './ObjectTypeSelect';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CardSectionSettings = () => {
  const translationOptions = useObjectTypeDefinitionTranslationOptions();
  const isAdminView = useIsAdminView();
  const pipelineId = usePipelineId();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(View, {
      inlineSize: "100%",
      as: "div",
      marginBlockEnd: "900",
      children: [isAdminView && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.settings.editor.adminViewWarning"
        })
      }), !isAdminView && /*#__PURE__*/_jsx(Alert, {
        type: "info",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.settings.editor.userViewWarning"
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: pipelineId ? 'crmObjectBoardCard.settings.editor.choosePipeline' : 'crmObjectBoardCard.settings.editor.chooseObjectType'
          })
        }), !isAdminView && /*#__PURE__*/_jsx(CardSectionSettingsResetButton, {})]
      })
    }), /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      as: "div",
      children: pipelineId ? /*#__PURE__*/_jsx(PipelineSelect, {}) : /*#__PURE__*/_jsx(ObjectTypeSelect, {})
    }), /*#__PURE__*/_jsxs(View, {
      as: "div",
      padding: "300",
      marginBlockStart: "900",
      paddingBlockEnd: "400",
      backgroundColor: "fill-surface-default",
      borderRadius: "200",
      borderWidth: "100",
      borderStyle: "solid",
      borderColor: "border-core-default",
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.settings.editor.recordName",
          options: translationOptions
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(SelectCardContentSection, {})
      }), /*#__PURE__*/_jsx(DraggableCardSettingRows, {}), /*#__PURE__*/_jsx(QuickActionSettings, {})]
    })]
  });
};